import { infoModalsEndpoints } from "./infoModals.api"

export const {
  useGetHasReadMutation,
  useGetInfoModalQuery,
  useMarkHasReadMutation,
  useGetInfoModalReadQuery
} = infoModalsEndpoints
